import { makeStyles } from '@material-ui/styles';

const VERTICAL_MARGINS = '64px';

export default makeStyles(theme => ({
  paper: {
    width: '100%',
    height: '100%',
    [theme.breakpoints.up('mobile')]: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      marginTop: theme.spacing(4),
      maxWidth: 1280,
      minWidth: 800,
      border: [1, 'solid', theme.palette.colors.border],
      height: `calc(100% - ${VERTICAL_MARGINS})`,
    },
  },
}));



// WEBPACK FOOTER //
// ./src/components/QuizPage/useStyles.js